
import { defineComponent } from 'vue'
import { $api } from '../common/apiService'

export default defineComponent({
  name: 'HeaderNavigation',
  data() {
    return {
      menuOpen: false,
    }
  },
  methods: {
    async logOut() {
      this.menuOpen = false
      await $api.auth.logout()
      await this.$store.dispatch('logOut')
      location.reload()
    },
    navigate(path: string) {
      this.menuOpen = false
      this.$router.push(path)
    },
  },
  computed: {
    loggedIn() {
      return this.$store.getters.isAuthenticated
    },
    adminAccess() {
      return this.$store.getters.isAdmin
    },
  },
})
